import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';
import { ErrorSnackBarData } from '@r1-compass-library/models';
import { HttpErrorBaseComponent } from './http-error-base/http-error-base.component';

@Component({
    selector: 'r1-compass-lib-http-error-snack-bar',
    template: ` <r1-compass-lib-http-error-base [data]="data" (dismiss)="onDismiss()" /> `,
    imports: [MatButtonModule, HttpErrorBaseComponent],
    encapsulation: ViewEncapsulation.None,
})
export class HttpErrorSnackBarComponent {
    readonly #matSnackBarService = inject(MatSnackBar);
    data = inject<ErrorSnackBarData>(MAT_SNACK_BAR_DATA);
    showExpanded = false;

    onDismiss(): void {
        this.#matSnackBarService.dismiss();
    }

    onExpand(): void {
        this.showExpanded = !this.showExpanded;
    }
}
